import { IorganizationBusinessData } from 'types/bussines';
import { create } from 'zustand';

interface IOrganizationState {
  organizationData: IorganizationBusinessData | undefined;
  setOrganizationData: (organizationData: IorganizationBusinessData) => void;
  generalLoader: boolean;
  setGeneralLoader: (generalLoader: boolean) => void;
}

const useOrganizationState = create<IOrganizationState>(set => ({
  organizationData: undefined,
  setOrganizationData: organizationData => set({ organizationData }),
  generalLoader: false,
  setGeneralLoader: generalLoader => set({ generalLoader })
}));

export default useOrganizationState;
